/**
 * Discriminator values for `event.data.type` in `window` "message" listeners
 * (postMessage from iframes, other tabs, or same-origin windows).
 * Central place to add more types when new handlers need a stable contract.
 */
const postMessageBridgeTypes = {
    PLATFORM_REDIRECT: "MYEDU_PLATFORM_REDIRECT",
    BOT_PORTAL_NAVIGATE: "MYEDU_BOT_PORTAL_NAVIGATE",
    APPLET_READY: "myedu:ready",
    APPLET_CONTEXT: "myedu:context",
};

export default postMessageBridgeTypes;
